module.exports = __webpack_public_path__ + "img/france-ovarian-cancer-female.50ffc76f.png";